import { utilNumber } from "./utilNumber";
var UtilArray = /** @class */ (function () {
    function UtilArray() {
        this.isLastArrayIndex = function (index, analyzedArray) {
            return index === analyzedArray.length - 1;
        };
    }
    UtilArray.prototype.getRandomElement = function (analyzedArray) {
        if (analyzedArray.length === 0) {
            return;
        }
        return analyzedArray[Math.floor(Math.random() * analyzedArray.length)];
    };
    UtilArray.prototype.adjustIndexToBoundaries = function (index, analyzedArray) {
        var maxIndexValue = analyzedArray.length - 1;
        return utilNumber.clamp(index, 0, maxIndexValue);
    };
    return UtilArray;
}());
export { UtilArray };
export var utilArray = new UtilArray();



//////////////////
// WEBPACK FOOTER
// ./src/utils/utilArray.ts
// module id = 477
// module chunks = 3